/* NutraSource Apothecary — theme scripts */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const body = document.body;
  const overlay = $('[data-overlay]');
  const CART_SECTION = 'cart-drawer-content';

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    const fmt = (window.NS && NS.moneyFormat) || '${{amount}}';
    const n = (Number(cents) / 100);
    const two = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const none = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return none;
      if (k === 'amount_with_comma_separator') return n.toFixed(2).replace('.', ',');
      return two;
    });
  }

  /* ---------- Drawers ---------- */
  let openDrawer = null;
  let lastFocus = null;
  const drawers = {
    menu: () => $('[data-menu-drawer]'),
    cart: () => $('[data-cart-drawer]'),
    filters: () => $('[data-filters]')
  };
  function open(name) {
    const el = drawers[name] && drawers[name]();
    if (!el) return false;
    close();
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    overlay.hidden = false;
    requestAnimationFrame(() => overlay.classList.add('is-visible'));
    body.classList.add('no-scroll');
    openDrawer = el;
    setTimeout(() => (el.querySelector('[data-close]') || el).focus(), 50);
    return true;
  }
  function close() {
    if (!openDrawer) return;
    openDrawer.classList.remove('is-open');
    overlay.classList.remove('is-visible');
    setTimeout(() => { if (!openDrawer) overlay.hidden = true; }, 300);
    body.classList.remove('no-scroll');
    openDrawer = null;
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      const name = opener.dataset.open;
      if (name === 'cart' && document.body.classList.contains('template-cart')) return;
      if (open(name)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-close]') || e.target === overlay) close();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { close(); toggleSearch(false); } });

  /* ---------- Header ---------- */
  const header = $('[data-header]');
  const onScroll = () => header && header.classList.toggle('is-scrolled', window.scrollY > 8);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  const searchPanel = $('[data-search-panel]');
  const searchBtn = $('[data-search-toggle]');
  function toggleSearch(force) {
    if (!searchPanel) return;
    const on = typeof force === 'boolean' ? force : !searchPanel.classList.contains('is-open');
    searchPanel.classList.toggle('is-open', on);
    searchBtn && searchBtn.setAttribute('aria-expanded', on);
    if (on) setTimeout(() => $('[data-predictive-input]', searchPanel).focus(), 30);
  }
  searchBtn && searchBtn.addEventListener('click', () => toggleSearch());

  const pInput = $('[data-predictive-input]');
  const pResults = $('[data-predictive-results]');
  let pTimer;
  pInput && pInput.addEventListener('input', () => {
    clearTimeout(pTimer);
    const q = pInput.value.trim();
    if (q.length < 2) { pResults.innerHTML = ''; return; }
    pTimer = setTimeout(async () => {
      try {
        const r = await fetch(`${NS.routes.predictive_search_url}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`);
        const data = await r.json();
        const items = (data.resources && data.resources.results && data.resources.results.products) || [];
        pResults.innerHTML = items.length
          ? `<div class="predictive__grid">${items.map(p => `
              <a class="predictive__item" href="${p.url}">
                ${p.image ? `<img src="${p.image}" alt="" loading="lazy">` : ''}
                <div><strong>${p.title}</strong><span>${p.vendor} · ${formatMoney(Math.round(parseFloat(p.price) * 100))}</span></div>
              </a>`).join('')}</div>`
          : `<p class="muted">No products found for “${q.replace(/</g, '&lt;')}”.</p>`;
      } catch (err) { pResults.innerHTML = ''; }
    }, 220);
  });

  /* ---------- Reveal ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(el => io.observe(el));
  } else { $$('.reveal').forEach(el => el.classList.add('is-in')); }

  /* ---------- Rails ---------- */
  $$('[data-rail]').forEach(rail => {
    const sec = rail.closest('section');
    const step = () => (rail.firstElementChild ? rail.firstElementChild.getBoundingClientRect().width + 20 : 300);
    const prev = sec && $('[data-rail-prev]', sec);
    const next = sec && $('[data-rail-next]', sec);
    prev && prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    next && next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  /* ---------- Goal index ---------- */
  $$('[data-goals]').forEach(sec => {
    const preview = $('[data-goal-preview]', sec);
    if (!preview) return;
    const imgs = $$('[data-goal-img]', preview);
    const label = $('[data-goal-label]', preview);
    $$('[data-goal-row]', sec).forEach(row => {
      const activate = () => {
        const i = row.dataset.goalRow;
        imgs.forEach(im => im.classList.toggle('is-active', im.dataset.goalImg === i));
        preview.style.background = row.dataset.tint;
        if (label) label.textContent = $('.goal-row__name', row).textContent;
      };
      row.addEventListener('mouseenter', activate);
      row.addEventListener('focus', activate);
    });
  });

  /* ---------- Tabs ---------- */
  $$('[data-tabs]').forEach(sec => {
    const tabs = $$('[data-tab]', sec);
    tabs.forEach(t => t.addEventListener('click', () => {
      tabs.forEach(x => { x.classList.toggle('is-active', x === t); x.setAttribute('aria-selected', x === t); });
      $$('[data-panel]', sec).forEach(p => { p.hidden = p.dataset.panel !== t.dataset.tab; });
    }));
  });

  /* ---------- Cart ---------- */
  const toast = $('[data-toast]');
  let toastT;
  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toastT);
    toastT = setTimeout(() => toast.classList.remove('is-visible'), 2600);
  }
  function renderCart(sections) {
    if (!sections || !sections[CART_SECTION]) return;
    const doc = new DOMParser().parseFromString(sections[CART_SECTION], 'text/html');
    const inner = $('[data-cart-inner]', doc);
    if (!inner) return;
    const bodyEl = $('[data-cart-body]');
    if (bodyEl) bodyEl.innerHTML = inner.outerHTML;
    const count = inner.dataset.count || '0';
    $$('[data-cart-count]').forEach(c => { c.textContent = count; c.dataset.count = count; });
  }
  async function addToCart(id, quantity, btn) {
    btn && btn.classList.add('is-loading');
    try {
      const res = await fetch(NS.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) || 1 }], sections: CART_SECTION })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to bag');
      renderCart(data.sections);
      if (document.body.classList.contains('template-cart')) { location.reload(); return; }
      if (!open('cart')) showToast('Added to your bag');
      if (btn) { btn.classList.add('is-added'); setTimeout(() => btn.classList.remove('is-added'), 1500); }
    } catch (err) {
      showToast(err.message);
    } finally { btn && btn.classList.remove('is-loading'); }
  }
  document.addEventListener('click', (e) => {
    const qa = e.target.closest('[data-quick-add]');
    if (qa) { e.preventDefault(); addToCart(qa.dataset.quickAdd, 1, qa); }
  });

  async function changeLine(line, quantity) {
    const wrap = $('[data-cart-body]');
    wrap && (wrap.style.opacity = '.55');
    try {
      const res = await fetch(NS.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity)), sections: CART_SECTION })
      });
      const data = await res.json();
      if (document.body.classList.contains('template-cart')) { location.reload(); return; }
      renderCart(data.sections);
    } catch (err) { showToast('Something went wrong'); }
    finally { wrap && (wrap.style.opacity = ''); }
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-line-qty]');
    if (b) { e.preventDefault(); changeLine(b.dataset.lineQty, b.dataset.qty); }
  });
  document.addEventListener('change', (e) => {
    const inp = e.target.closest('[data-line-input]');
    if (inp) changeLine(inp.dataset.lineInput, inp.value);
  });

  /* ---------- Product page ---------- */
  const pSec = $('[data-product-section]');
  if (pSec) {
    const product = JSON.parse($('[data-product-json]').textContent);
    const form = $('[data-product-form]', pSec);
    const idInput = $('[data-variant-id]', form);
    const qtyInput = $('[data-qty-input]', form);
    const addBtn = $('[data-add-btn]', form);
    const addLabel = $('[data-add-label]', form);
    const priceEl = $('[data-price]', pSec);
    const stickyPrice = $('[data-sticky-price]');
    const stickyAdd = $('[data-sticky-add]');

    // Gallery
    const slides = $$('[data-slide]', pSec);
    const thumbs = $$('[data-thumb]', pSec);
    let gi = 0;
    const show = (i) => {
      if (!slides.length) return;
      gi = (i + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === gi));
      thumbs.forEach(t => t.classList.toggle('is-active', Number(t.dataset.thumb) === Number(slides[gi].dataset.slide)));
    };
    thumbs.forEach(t => t.addEventListener('click', () => show(slides.findIndex(s => s.dataset.slide === t.dataset.thumb))));
    const gp = $('[data-g-prev]', pSec), gn = $('[data-g-next]', pSec);
    gp && gp.addEventListener('click', () => show(gi - 1));
    gn && gn.addEventListener('click', () => show(gi + 1));
    let tx = null;
    const main = $('.gallery__main', pSec);
    main && main.addEventListener('touchstart', e => { tx = e.touches[0].clientX; }, { passive: true });
    main && main.addEventListener('touchend', e => {
      if (tx === null) return;
      const dx = e.changedTouches[0].clientX - tx;
      if (Math.abs(dx) > 40) show(gi + (dx < 0 ? 1 : -1));
      tx = null;
    });

    // Quantity & bundle tiers
    const bundleRadios = $$('input[name="bp"]', pSec);
    const setQty = (q) => {
      q = Math.max(1, Number(q) || 1);
      qtyInput.value = q;
      bundleRadios.forEach(r => { r.checked = Number(r.value) === Math.min(q, 3); });
    };
    $$('[data-qty-step]', form).forEach(b => b.addEventListener('click', () => setQty(Number(qtyInput.value) + Number(b.dataset.qtyStep))));
    qtyInput.addEventListener('change', () => setQty(qtyInput.value));
    bundleRadios.forEach(r => r.addEventListener('change', () => setQty(r.value)));

    // Variants
    const updateVariant = () => {
      const opts = product.options.map((_, i) => {
        const checked = $(`input[data-option="${i + 1}"]:checked`, form);
        return checked ? checked.value : null;
      });
      const v = product.variants.find(v => v.options.every((o, i) => o === opts[i]));
      if (!v) { addBtn.disabled = true; addLabel.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      priceEl.textContent = formatMoney(v.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      addBtn.disabled = !v.available;
      if (stickyAdd) stickyAdd.disabled = !v.available;
      addLabel.textContent = v.available ? 'Add to bag' : 'Sold out';
      const url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
      if (v.featured_media) {
        const idx = slides.findIndex(s => product.media && product.media[Number(s.dataset.slide)] && product.media[Number(s.dataset.slide)].id === v.featured_media.id);
        if (idx >= 0) show(idx);
      }
      const bundle = $('[data-bundle]', pSec);
      $$('[data-bp-price]', pSec).forEach(el => {
        const n = Number(el.dataset.bpPrice);
        const pct = bundle ? Number(n === 2 ? bundle.dataset.t2 : n === 3 ? bundle.dataset.t3 : 0) : 0;
        if (n === 1) el.textContent = formatMoney(v.price);
        else if (pct) el.innerHTML = `<s>${formatMoney(v.price * n)}</s>${formatMoney(Math.floor(v.price * n * (100 - pct) / 100))}`;
      });
    };
    $$('input[data-option]', form).forEach(i => i.addEventListener('change', updateVariant));

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      addToCart(idInput.value, qtyInput.value, addBtn);
    });
    stickyAdd && stickyAdd.addEventListener('click', () => addToCart(idInput.value, qtyInput.value, stickyAdd));

    // Sticky bar
    const sticky = $('[data-sticky-buy]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const past = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
        sticky.setAttribute('aria-hidden', !past);
        if (stickyAdd) stickyAdd.tabIndex = past ? 0 : -1;
      }).observe($('.buy-row', form));
    }
  }

  /* ---------- Recommendations ---------- */
  $$('[data-recs]').forEach(async (sec) => {
    if (sec.children.length) return;
    try {
      const r = await fetch(sec.dataset.url);
      const html = await r.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-recs]', doc);
      if (fresh && fresh.innerHTML.trim()) sec.innerHTML = fresh.innerHTML;
      else sec.style.display = 'none';
    } catch (e) { sec.style.display = 'none'; }
  });

  /* ---------- Collection: sort & filters ---------- */
  const sort = $('[data-sort]');
  sort && sort.addEventListener('change', () => {
    const url = new URL(location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    location.href = url.toString();
  });
  const facets = $('[data-filters]');
  if (facets) {
    facets.addEventListener('change', (e) => {
      if (e.target.matches('[data-autosubmit]')) facets.requestSubmit ? facets.requestSubmit() : facets.submit();
    });
    facets.addEventListener('submit', () => {
      $$('input', facets).forEach(i => { if ((i.type === 'number' || i.type === 'hidden') && i.value === '') i.disabled = true; });
    });
  }
})();